import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider } from 'firebase/auth';
import { env } from '@/shared/config/env';

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
};

// Initialize Firebase only if it hasn't been initialized yet
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);

/*
 * Point auth at a local Firebase Auth emulator when one is configured (the
 * full-stack dev mode in scripts/stack.sh). Read straight off import.meta.env
 * rather than through `env`, whose schema requires everything it lists.
 *
 * **`import.meta.env.DEV` is the load-bearing half of this condition.** It is
 * false in every `vite build`, whatever the mode and whatever the env files
 * say, so a built bundle cannot be made to talk to an emulator. That is not
 * theoretical: a deployed staging console once opened the emulator's sign-in
 * popup instead of Google's, because Vite loads the developer's untracked
 * `.env.local` in every mode and `.env.stg` had no key of this name to
 * override it with. The env plumbing is fixed too (see vite.config.ts's
 * envDir), but the guarantee belongs here, where it cannot be configured away.
 */
if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(auth, `http://${import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST}`, {
    disableWarnings: true,
  });
}

/**
 * The admin console's only sign-in method.
 *
 * `prompt: 'select_account'` because staff routinely have a personal Google
 * account signed in alongside the work one, and without it the popup silently
 * reuses whichever came first — which then fails the domain check with no
 * obvious way to try the other.
 *
 * No `hd` parameter: two domains are allowed and `hd` takes one. The allowlist
 * is enforced server-side by `internalSignIn`, which is where it has to be
 * anyway — a client hint is a hint.
 */
export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: 'select_account',
});
